module.exports = __webpack_public_path__ + "img/change-status-roster-blue-outline.f0a87b55.svg";